import { io } from "socket.io-client";
const SOCKET_URL = process.env.SOCKET_URL || "https://groupchat.buildpot.in";
export const socket = io(SOCKET_URL, {
    autoConnect: false,
});
export default socket;
